import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const MentionsLegales = () => {
  return (
    <>
      <SEO 
        title="Mentions Légales - Orion Industrie"
        description="Mentions légales d'Orion Industrie - Expert en équipements de quai et transbordement. Informations légales, SIRET, hébergeur et contact."
        url="https://orion-industrie.eu/mentions-legales"
      />
      
      <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-slate-900 text-white py-6">
        <div className="container mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="text-white hover:text-orange-400 mb-4">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Retour à l'accueil
            </Button>
          </Link>
          <h1 className="text-4xl font-bold">Mentions Légales</h1>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 md:p-12">
          
          {/* Identification de l'entreprise */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              1. Identification de l'entreprise
            </h2>
            <div className="space-y-2 text-gray-700">
              <p><strong>Raison sociale :</strong> Orion Industrie</p>
              <p><strong>Forme juridique :</strong> EURL</p>
              <p><strong>Nom du gérant :</strong> Benoit Manin</p>
              <p><strong>Adresse du siège social :</strong><br />
                2035 route de Villars<br />
                58490 Saint Parize le Chatel<br />
                France
              </p>
              <p><strong>SIRET :</strong> 105 168 207 00014</p>
              <p><strong>Email :</strong> gestion@orion-industrie.eu</p>
              <p><strong>Téléphone :</strong> 06 59 45 25 62</p>
            </div>
          </section>

          {/* Directeur de publication */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              2. Directeur de la publication
            </h2>
            <p className="text-gray-700">
              Le directeur de la publication du site est <strong>Benoit Manin</strong>.
            </p>
          </section>

          {/* Hébergement */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              3. Hébergement du site
            </h2>
            <div className="text-gray-700">
              <p><strong>Hébergeur :</strong> Emergent AI, Inc.</p>
              <p><strong>Adresse :</strong> 2261 Market Street #4350, San Francisco, CA 94114, États-Unis</p>
              <p><strong>Site web :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:underline">https://emergent.sh</a></p>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              4. Propriété intellectuelle
            </h2>
            <p className="text-gray-700">
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, graphismes) est la propriété exclusive d'Orion Industrie, 
              sauf mention contraire. Toute reproduction, distribution, modification ou utilisation, même partielle, sans autorisation 
              écrite préalable est strictement interdite et constituerait une contrefaçon sanctionnée par les articles L.335-2 et 
              suivants du Code de la propriété intellectuelle.
            </p>
          </section>

          {/* Données personnelles */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              5. Protection des données personnelles
            </h2>
            <p className="text-gray-700">
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
              vous disposez de droits sur vos données personnelles. Pour plus d'informations, consultez notre{' '}
              <Link to="/politique-confidentialite" className="text-orange-500 hover:underline font-semibold">
                Politique de confidentialité
              </Link>.
            </p>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              6. Cookies
            </h2>
            <p className="text-gray-700">
              Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. En continuant à naviguer 
              sur ce site, vous acceptez l'utilisation de cookies conformément à notre politique de confidentialité.
            </p>
          </section>

          {/* Responsabilité */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              7. Limitation de responsabilité
            </h2>
            <p className="text-gray-700">
              Orion Industrie s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Orion Industrie ne peut 
              garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition. En conséquence, Orion Industrie décline 
              toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4 border-b-2 border-orange-500 pb-2">
              8. Contact
            </h2>
            <p className="text-gray-700">
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
            </p>
            <div className="mt-4 p-4 bg-orange-50 rounded-lg border-l-4 border-orange-500">
              <p className="text-gray-700"><strong>Email :</strong> gestion@orion-industrie.eu</p>
              <p className="text-gray-700"><strong>Téléphone :</strong> 06 59 45 25 62</p>
            </div>
          </section>

          {/* Footer */}
          <div className="mt-12 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default MentionsLegales;